import FormWrapper from 'app/frontend/base/components/FormWrapper'
import { useGuild } from 'app/frontend/base/config/context/guild'
import { z } from 'zod'
import AccessRestrictionTable from 'app/frontend/base/pages/TeamDashboard/subpages/TeamSettings/components/AccessSectionTable'
import {
  accessRestrictionSchema,
  EditableAccessRestriction,
  validateAccessRestrictions,
} from 'app/frontend/base/pages/TeamDashboard/subpages/TeamSettings/components/accessRestrictionSchema'

const formSchema = z
  .object({
    access_restrictions_attributes: z.array(accessRestrictionSchema),
  })
  .superRefine(validateAccessRestrictions)

const AccessSection = () => {
  const { guild } = useGuild()

  if (!guild) return null

  return (
    <div>
      <h4>Access rules</h4>

      <p className='mt-6'>
        You can grant access to your guild with rules specified here. Guild
        rules will apply to all teams. Users will have access according to the
        matching rule of the highest level.{' '}
        <em>
          The in-game guild master will always have admin access, regardless of
          rules.
        </em>
      </p>

      <p className='mt-2 mb-8'>
        Sections that you have no (or only user specific) rules for will use the
        base access rules. However, users without base access will not be able
        to see any sections, regardless of any section rules. Users with base
        level admin access will always have admin access to all sections.
      </p>

      <FormWrapper<
        wowaudit.Guild & {
          access_restrictions_attributes: EditableAccessRestriction[]
        }
      >
        key={guild.id}
        formSchema={formSchema}
        entity={{
          ...guild,
          access_restrictions_attributes: guild.accessRestrictions ?? [],
        }}
        entityType='guild'
        onSave={(form, data) => {
          form.reset({
            ...data,
            access_restrictions_attributes: data.accessRestrictions ?? [],
          })
        }}
      >
        <AccessRestrictionTable scope='owner' />
      </FormWrapper>
    </div>
  )
}

export default AccessSection
